"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomPageValidationWidget = void 0;
var React = require("react");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var react_html_parser_1 = require("react-html-parser");
var journey_services_1 = require("@athena-portal/journey-services");
var PageValidationMessage_1 = require("../helpers/PageValidationMessage");
var CustomPageValidationWidget = /** @class */ (function (_super) {
    __extends(CustomPageValidationWidget, _super);
    function CustomPageValidationWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleClose = _this.handleClose.bind(_this);
        return _this;
    }
    CustomPageValidationWidget.prototype.render = function () {
        var journeyState = this.props.engine.getJourneyState();
        var hidePageValidationMessage = journeyState["hidePageValidationErrorMessage"] || false;
        var bottomText = this.renderHtml(this.getSetting("bottomText")) || "Please try again.";
        var topText = this.getSetting("topText");
        var validationField = this.bindFromField(this.getSetting("validationField"));
        if (!validationField && bottomText && !hidePageValidationMessage) {
            return (React.createElement(PageValidationMessage_1.PageValidationMessage, { topText: topText, bottomText: bottomText, handleCloseFunction: this.handleClose }));
        }
        else {
            return null;
        }
    };
    CustomPageValidationWidget.prototype.renderHtml = function (htmlText) {
        return (0, react_html_parser_1.default)(this.renderTemplate(htmlText, true), {
            transform: function (node) {
                if (node.name === 'script' || node.name === 'style' || node.name === 'link') {
                    return null;
                }
                return;
            }
        });
    };
    CustomPageValidationWidget.prototype.renderTemplate = function (template, escapeFields) {
        return journey_services_1.ExpressionEvaluator.renderTemplate(template, this.props.interaction, escapeFields);
    };
    CustomPageValidationWidget.prototype.handleClose = function () {
        var _a;
        this.props.engine.setJourneyState((_a = {}, _a["hidePageValidationErrorMessage"] = true, _a));
    };
    return CustomPageValidationWidget;
}(plugin_journey_1.WidgetBase));
exports.CustomPageValidationWidget = CustomPageValidationWidget;
//# sourceMappingURL=CustomPageValidationWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/CustomPageValidationWidget.js
// module id = 3629
// module chunks = 0